import { ApiError, errorMessage } from 'api/call'

/** 422 on create/update carries `errors` keyed by attribute (ValidationErrorResponse). */
export const validationMessage = (error: unknown, fallback: string) => {
  const errors = (error instanceof ApiError &&
    (error.body as { errors?: unknown } | undefined)?.errors) as
    Record<string, string[]> | undefined
  if (errors && typeof errors === 'object' && !Array.isArray(errors)) {
    return Object.entries(errors)
      .map(([field, messages]) => `${field}: ${[messages].flat().join(', ')}`)
      .join('\n')
  }
  return errorMessage(error, fallback)
}
